<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '90px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="生产基地">
              <a-select show-search option-filter-prop="children" filter v-model="queryParams.manufactureBaseCode">
                <a-select-option v-for="(item) in manufactureBaseCodeList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="加工组织">
              <global-select
                :value.sync="queryParams.organizationCode"
                selectType="selectAssembleMultipleSearch"
                :default-active-first-option="defaultSelect"
                requestApi="/system/user/inventOrgList"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :dropdown-match-select-width="false"
                :assembleLabel="true"
                searchParam="organizationName"
                :setParams="{ pageSize: 9999999 }"
                @change="getBomWorkshopFindListNew"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="车间类型">
              <a-select show-search option-filter-prop="children" v-model="queryParams.workshopType" mode="multiple" :max-tag-text-length="2" :max-tag-count="1">
                <a-select-option v-for="(item) in workshopTypeList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="车间说明">
              <a-select show-search option-filter-prop="children" v-model="queryParams.workshopCode" mode="multiple" :max-tag-text-length="2" :max-tag-count="1">
                <a-select-option v-for="(item) in workshopCodeListNew" :key="item.workshopCode">{{ item.workshopDesc }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="产线说明">
              <a-select show-search option-filter-prop="children" v-model="queryParams.prodLineCode" mode="multiple" :max-tag-text-length="2" :max-tag-count="1">
                <a-select-option v-for="(item) in prodLineCodeList" :key="item.prodLineCode">{{ item.prodLineDesc }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="排线优先顺序">
              <a-input-number v-model="queryParams.linePriority" :min="0" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="状态">
              <a-select v-model="queryParams.prodLineStatus" allowClear>
                <a-select-option v-for="(item) in statusOptions" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiBomProdLineNewExport" ref="download" />
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['bom:bomProdLine:add']">新建</a-button>
      <a-button @click="importExcelHandleOpen" type="primary" v-hasPermi="['bom:bomProdLine:import']">导入</a-button>
      <a-button @click="handleExport" v-hasPermi="['bom:bomProdLine:export']">导出</a-button>
      <a-button @click="importTemplate" v-hasPermi="['bom:bomProdLine:template']">下载模板</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.PRODUCTION_LINE_LIST, // 表格方案配置唯一值
              }"
        >
          <span slot="shiftsNameTitle">
            <i class="toRequired">*</i>班次
          </span>
          <span slot="lineChangeTimeTitle">
            <i class="toRequired">*</i>换产时间(时)
          </span>
          <span slot="unitCapacityTitle">
            <i class="toRequired">*</i>产能(套/时)
          </span>
          <span slot="supplySublibraryTitle">
            <i class="toRequired">*</i>自动扣料仓
          </span>
          <span slot="completedSublibraryTitle">
            <i class="toRequired">*</i>完工子库
          </span>
          <span slot="totalNumOfPeopleTitle">
            <i class="toRequired">*</i>标准总人数界面
          </span>
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a v-if="!isEdit || currentId !== text.record.id" @click="handleEdit(text.record)" v-hasPermi="['bom:bomProdLine:edit']">编辑</a>
                <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
                <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
              </span>
              <span v-else-if="item.type === 'select'">
                <span v-if="!isEdit || currentId !== text.record.id">{{ meaning(text.record, item.dataIndex) }}</span>
                <global-select
                  v-if="isEdit && currentId === text.record.id"
                  :value.sync="text.record[item.dataIndex]"
                  :selectType="item.selectType ? item.selectType : 'select'"
                  :focusGet="item.focusGet ? item.focusGet : false"
                  :requestApi="item.requestApi"
                  :selectData="setArray(item.dataList)"
                  :selectItem="{ value: item.value, label: item.label }"
                  :searchParam="item.searchParam ? item.searchParam : ''"
                  :setParams="item.setParams ? setParamsHandle(text.record, item.dataIndex) : null"
                  :sourseField="item.sourseField ? item.sourseField : ''"
                  :allowClear="false"
                  size="small"
                  :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
                  @change="(val, list)=>{ handleGSChange(val,list,item,text.record)}"
                />
              </span>
              <span v-else-if="item.type === 'input'">
                <span v-if="!isEdit || currentId !== text.record.id">{{ text.record[item.dataIndex] }}</span>
                <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record[item.dataIndex]" size="small" />
              </span>
              <span v-else-if="item.type === 'inputNumber'">
                <span v-if="!isEdit || currentId !== text.record.id">{{ text.record[item.dataIndex] }}</span>
                <a-input-number v-if="isEdit && currentId === text.record.id" v-model="text.record[item.dataIndex]" :min="0" size="small" />
              </span>
              <span v-else-if="item.type === 'switch'">
                <a-switch :disabled="!isEdit || currentId !== text.record.id" :checked="text.record[item.dataIndex] === 'Y'" @change="statusOnChange(text.record, item.dataIndex)" />
              </span>
              <span v-else-if="item.type === 'text'">{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else-if="item.dataIndex === 'workshopCodeNew'">{{ text.record['workshopCode'] }}</span>
              <span v-else>{{ text.text }}</span>
            </div>
          </template>
        </ls-api-table>
        <!-- 底部分页按钮 -->
        <!-- <Page ref="page" :pageParams.sync="pageParams" @getList="getList" /> -->
        <production-line-add
          ref="createModal"
          :workshopTypeList="workshopTypeList"
          :inventOrg="inventOrg"
          :manufactureBaseCodeList="manufactureBaseCodeList"
          @handle-success="handleOk"
        />
      </div>
      <!-- 上传文件 -->
      <a-modal
        :title="upload.title"
        :visible="excelVisible"
        @ok="importExcelHandleCancel"
        @cancel="importExcelHandleCancel"
      >
        <a-upload-dragger
          name="file"
          accept=".xlsx, .xls"
          :multiple="true"
          :headers="upload.headers"
          :action="upload.url + '?updateSupport=' + upload.updateSupport"
          @change="importExcelHandleChange"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">
            请将文件拖拽到此处上传
          </p>
          <p class="ant-upload-hint">
            支持单个或批量上传，也可以点击后选择文件上传
          </p>
        </a-upload-dragger>
      </a-modal>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiBomProdLineUpdate, apiBomWorkshopFindList, apiBomProdLineFindList, apiRoutingCalendarShiftsList, apiBomProdLineList, apiBomProdLineNewExport } from '@/api/mes/basedata/productionLine'
import ProductionLineAdd from './components/production-line-add'
import Cookies from 'js-cookie';
import { generateLsTableResData } from '@/utils/util.js';
import cacheSearch from '@/mixins/cacheSearch'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  name: 'ProductionLine',
  components: {
    DownloadModal,
    ProductionLineAdd
  },
  mixins: [cacheSearch],
  data () {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
      apiBomProdLineNewExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiBomProdLineList, true),
        pageCurrent: true
      },
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + '/bom/bomProdLine/import'
      },
      isEdit: false,
      currentId: "",
      pageParams: {
        automatic: true,
        pageUrl: '/bom/bomProdLine/list',
        tableLoading: false
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        manufactureBaseCode: undefined,
        organizationCode: undefined,
        workshopType: undefined,
        workshopCode: undefined,
        prodLineCode: undefined,
        linePriority: undefined,
        prodLineStatus: undefined
      },
      // 状态快码
      statusOptions: [
        {
          dictLabel: "有效",
          dictValue: "Y"
        },
        {
          dictLabel: "无效",
          dictValue: "N"
        }
      ],
      // 快码表格数据
      typeList: [],
      // 表格字段
      columns: [
        {
          title: '生产基地',
          dataIndex: 'manufactureBaseCode',
          align: 'center',
          width: 170,
          scopedSlots: { customRender: 'manufactureBaseCode' },
          type: "select",
          dataList: 'manufactureBaseCodeList',
          value: 'lookupCode',
          label: 'lookupValue'
        },
        {
          title: '加工组织',
          width: 130,
          dataIndex: 'organizationName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '供应商',
          dataIndex: 'supplierName',
          ellipsis: true,
          width: 250,
          align: 'center'
        },
        {
          title: '供应商简称',
          dataIndex: 'supplierCode',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '车间类型',
          dataIndex: 'workshopType',
          ellipsis: true,
          width: 100,
          align: 'center'
        },
        {
          title: '车间编码',
          dataIndex: 'workshopCodeNew',
          scopedSlots: { customRender: 'workshopCodeNew' },
          align: 'center',
          width: 120
        },
        {
          title: '车间说明',
          width: 170,
          dataIndex: 'workshopCode',
          scopedSlots: { customRender: 'workshopCode' },
          align: 'center',
          type: "select",
          setParams: true,
          sourseField: "res",
          requestApi: '/bom/bomWorkshop/findList',
          value: 'workshopCode',
          label: 'workshopDesc',
          ellipsis: true
        },
        {
          title: '产线编码',
          dataIndex: 'prodLineCode',
          width: 120,
          align: 'center'
        },
        {
          title: '产线说明',
          dataIndex: 'prodLineDesc',
          width: 120,
          scopedSlots: { customRender: 'prodLineDesc' },
          align: 'center',
          type: "input",
          ellipsis: true
        },
        {
          title: '排线优先顺序',
          dataIndex: 'linePriority',
          width: 120,
          scopedSlots: { customRender: 'linePriority' },
          align: 'center',
          type: "inputNumber"
        },
        {
          // title: '班次',
          customTitle: '班次',
          dataIndex: 'shiftsId',
          scopedSlots: { customRender: 'shiftsId', title: "shiftsNameTitle" },
          align: 'center',
          width: 170,
          type: "select",
          setParams: true,
          requestApi: "/bom/routingCalendar/shiftsList",
          value: 'id',
          label: 'shiftsName'
        },
        {
          title: '工作时间(时/天)',
          dataIndex: 'workingHours',
          width: 150,
          align: 'center'
        },
        {
          // title: '换产时间(时)',
          customTitle: '换产时间(时)',
          dataIndex: 'lineChangeTime',
          width: 120,
          scopedSlots: { customRender: 'lineChangeTime', title: "lineChangeTimeTitle" },
          align: 'center',
          type: "inputNumber"
        },
        {
          // title: '产能(套/时)',
          customTitle: '产能(套/时)',
          dataIndex: 'unitCapacity',
          width: 120,
          scopedSlots: { customRender: 'unitCapacity', title: "unitCapacityTitle" },
          align: 'center',
          type: "inputNumber"
        },
        {
          title: '产能负荷比例(%)',
          dataIndex: 'capacityLoad',
          width: 150,
          scopedSlots: { customRender: 'capacityLoad' },
          align: 'center',
          type: "inputNumber"
        },
        {
          // title: '标准总人数界面',
          customTitle: '标准总人数界面',
          dataIndex: 'totalNumOfPeople',
          width: 150,
          scopedSlots: { customRender: 'totalNumOfPeople', title: "totalNumOfPeopleTitle" },
          align: 'center',
          type: "inputNumber"
        },
        {
          // title: '自动扣料仓',
          customTitle: '自动扣料仓',
          dataIndex: 'supplySublibrary',
          scopedSlots: { customRender: 'supplySublibrary', title: "supplySublibraryTitle" },
          align: 'center',
          width: 170,
          type: "select",
          selectType: "selectSearch",
          focusGet: true,
          searchParam: "warehouseCode",
          setParams: true,
          requestApi: '/inv/invCallRequestLines/intoSublibraryBox',
          value: 'realValue',
          label: 'label'
        },
        {
          title: '自动扣料仓名称',
          dataIndex: 'supplySublibraryName',
          width: 150,
          align: 'center'
        },
        {
          title: '供应货位',
          dataIndex: 'supplyLocation',
          scopedSlots: { customRender: 'supplyLocation' },
          align: 'center',
          width: 170,
          type: "select",
          selectType: "selectSearch",
          focusGet: true,
          searchParam: "locationCode",
          setParams: true,
          requestApi: '/inv/invCallRequestLines/intoGoodsAllocationBox',
          value: 'realValue',
          label: 'label'
        },
        {
          // title: '完工子库',
          customTitle: '完工子库',
          dataIndex: 'completedSublibrary',
          scopedSlots: { customRender: 'completedSublibrary', title: "completedSublibraryTitle" },
          align: 'center',
          width: 170,
          type: "select",
          selectType: "selectSearch",
          focusGet: true,
          searchParam: "warehouseCode",
          setParams: true,
          requestApi: '/inv/invCallRequestLines/intoSublibraryBox',
          value: 'realValue',
          label: 'label'
        },
        {
          title: '完工子库名称',
          dataIndex: 'completedSublibraryName',
          width: 150,
          align: 'center'
        },
        {
          title: '完工货位',
          dataIndex: 'completedLocation',
          scopedSlots: { customRender: 'completedLocation' },
          align: 'center',
          width: 170,
          type: "select",
          selectType: "selectSearch",
          focusGet: true,
          searchParam: "locationCode",
          setParams: true,
          requestApi: '/inv/invCallRequestLines/intoGoodsAllocationBox',
          value: 'realValue',
          label: 'label'
        },
        {
          title: '状态',
          dataIndex: 'prodLineStatus',
          width: 120,
          scopedSlots: { customRender: 'prodLineStatus' },
          align: 'center',
          type: "switch"
        },
        {
          title: '最后修改人',
          width: 120,
          dataIndex: 'updateName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 150,
          ellipsis: true,
          align: 'center',
          type: "text"
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          width: 120,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 150,
          ellipsis: true,
          align: 'center',
          type: "text"
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      workshopCodeListNew: [], // 车间编码下拉框
      prodLineCodeList: [], // 产线编码下拉框
      workshopTypeList: [], // 车间类型下拉框
      manufactureBaseCodeList: [], // 生产基地下拉框
      shiftsNameList: [] // 班次下拉框
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  created () {
    this.getLookupList('MES_MANUFACTURE_BASE', 'manufactureBaseCodeList')
    this.getLookupList('MES_WORKSHOP_TYPE', 'workshopTypeList')
    // 处理缓存逻辑
    this.getCacheNoRef('organizationCode')
    this.getBomWorkshopFindListNew()
    this.getBomProdLineFindList()
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 表单搜索
    onSearch () {
      this.isEdit = false
      this.$refs.dataTable.searchParams = this.queryParams;
      this.setSearchCache(this.queryParams) // 设置缓存
      this.$refs.dataTable.getData();
    },
    handleGSChange (value, list, item, record) {
     // @change="selectChange(record, item.dataIndex)"
    //  车间说明
      if (item.dataIndex === 'workshopCode') {
        const filteredRecords = list.filter(obj => obj.workshopCode === value);
        if (filteredRecords) {
          record.workshopId = filteredRecords[0].id
        }
      } else if(item.dataIndex === 'completedSublibrary') {
        record.completedLocation = '' // 变化完工子库时，清空完工库位
      } else {
        this.selectChange(record, item.dataIndex)
      }
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }

      this.getFindList(record.organizationCode)

      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      if (!record.organizationCode ||
        !record.shiftsId ||
        !record.supplySublibrary ||
        !record.completedSublibrary ||
        !record.totalNumOfPeople) {
        this.$message.warning('必填项不能为空！')
        return
      }
      if ((record.linePriority || record.linePriority === 0) && Number(record.linePriority) <= 0) {
        this.$message.warning('排线优先顺序需大于0')
        return
      }
      if (!record.lineChangeTime || Number(record.lineChangeTime) <= 0) {
        this.$message.warning('换产时间(时)需大于0')
        return
      }
      if (!record.unitCapacity || Number(record.unitCapacity) <= 0) {
        this.$message.warning('产能(套/时)需大于0')
        return
      }
      if (record.capacityLoad === 0) {
        this.$message.warning('产能负荷比例(%) 不能为0')
        return
      }
      apiBomProdLineUpdate(record).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          // this.$refs.page.getFirstPage(this.queryParams)
          this.isEdit = false
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
     // this.$refs.page.getFirstPage(this.queryParams)
     this.onSearch()
     this.isEdit = false
    },
    /** 查询列表 */
    getList (data) {
      this.typeList = data
      this.isEdit = false
    },
    // 新增/修改框事件
    handleOk () {
     // this.$refs.page.getFirstPage(this.queryParams)
     this.onSearch()
    },
    /** 搜索按钮操作 */
    handleQuery () {
     // this.$refs.page.getFirstPage(this.queryParams)
     this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        manufactureBaseCode: undefined,
        organizationCode: undefined,
        workshopType: undefined,
        workshopCode: undefined,
        prodLineCode: undefined,
        linePriority: undefined,
        prodLineStatus: undefined
      }
      this.handleQuery()
    },
    statusOnChange (record, dataIndex) {
      record[dataIndex] = record[dataIndex] === 'Y' ? 'N' : 'Y'
    },
    selectChange (record, dataIndex) {
      if (dataIndex === "shiftsId") {
        record.workingHours = this.$getFlagName(this.shiftsNameList, record.shiftsId, "id", "calculateTime")
      }
    },
    meaning (record, dataIndex) {
      if (dataIndex === "shiftsId") {
        return record.shiftsName
      }
      if (dataIndex === "manufactureBaseCode") {
        return record.manufactureBaseName
      }
      if (dataIndex === "workshopCode") {
        return record.workshopDesc
      }
      return record[dataIndex]
    },
    setParamsHandle (record, dataIndex) {
      if (dataIndex === "workshopCode") {
        return { organizationCode: record.organizationCode }
      }
      if (dataIndex === "shiftsId") {
        return { organizationCode: record.organizationCode }
      }

      if (dataIndex === "supplySublibrary" || dataIndex === "completedSublibrary") {
        return { organizationCode: record.organizationCode }
      }
      if (dataIndex === "supplyLocation") {
        return { subinventoryCode: record.supplySublibrary }
      }
      if (dataIndex === "completedLocation") {
        return { subinventoryCode: record.completedSublibrary }
      }
    },
    setArray (arr) {
      return this[arr]
    },
    getBomWorkshopFindListNew () {
      // 车间编码
      apiBomWorkshopFindList({ organizationCode: this.queryParams.organizationCode }).then(res => {
        this.workshopCodeListNew = res
      })
      this.getBomProdLineFindList()
    },
    // 产线编码
    getBomProdLineFindList () {
      apiBomProdLineFindList({ organizationCode: this.queryParams.organizationCode }).then(res => {
        this.prodLineCodeList = res
      })
    },
    // 班次
    getFindList (val) {
      apiRoutingCalendarShiftsList({ organizationCode: val }).then(res => {
        this.shiftsNameList = res.data
      })
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.handleQuery()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.excelVisible = true
    },
    /** 下载模板操作 */
    importTemplate () {
      this.download('bom/bomProdLine/template', {
        ...this.queryParams
      }, `产线导入模板_${new Date().getTime()}.xlsx`)
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
      // this.download('bom/bomProdLine/export', {
      //   ...this.queryParams
      // }, `产线_${new Date().getTime()}.xlsx`)
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
.page-header-content{
  /deep/.ant-select{
    width: 120px;
  }
}
/deep/.ant-input-number{
  width: 100%;
}
</style>
